export enum validationMessages {
    NOT_ENOUGH_POINTS = 'Debe haber al menos 3 puntos para crear un polígono.',
    POINT_WITHOUT_SAVE = 'Tiene alguna fila sin guardar en la lista de coordenadas.',
    NO_POLYGON_TO_SAVE = 'No hay ningún polígono guardado. ',
    DIFF_AREA_BIG = 'La diferencia con el área declarada es mayor a 20%.',
    NOT_VALID_LAT_LONG = 'Las coordenadas no son válidas.',
}